import { SceneLoader } from "@babylonjs/core/Loading/sceneLoader";
import "@babylonjs/loaders/glTF/2.0";
import { Vector3 } from "@babylonjs/core/Maths/math";

export default class Land {

    constructor(scene) {
        // SceneLoader.ImportMeshAsync(null, "assets/models/", "land.gltf", scene)
        //     .then(
        //         (result) => {
        //             result.meshes[0].receiveShadows = true;

        //             result.meshes[0].checkCollisions = true;
        //             result.meshes[1].checkCollisions = true;

        //             result.meshes[0].position.x = -10;
        //             result.meshes[0].position.y = -20;
        //             result.meshes[0].position.z = -15;

        //             result.meshes[0].scaling = new Vector3(4, 5.2, 4);

        //             console.log(result);
        //         }
        //     );
    }
}